import { render, staticRenderFns } from "./VtComboSelect.vue?vue&type=template&id=4eb16563&"
import script from "./VtComboSelect.vue?vue&type=script&lang=js&"
export * from "./VtComboSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports